<div
  class="label-container"
  [class.attention]="hasValueChanged$ | async"
  (click)="onLabelClick($event)"
>
  <div class="attribute">
    <span
      class="caption attribute-name"
      [class.is-invalid-value]="isInvalidValue$ | async"
      >{{ attribute.name }}</span
    >
    <mat-icon
      *ngIf="attribute.isDynamic"
      svgIcon="dynamicTag"
      class="dynamic-icon"
      [class.is-dynamic-frame]="isDynamicFrame$ | async"
    ></mat-icon>
  </div>
  <ng-content></ng-content>
  <div
    *ngIf="isDifferentFromDefault$ | async"
    class="edited-value-marker"
  ></div>
</div>
